import React, { useState } from 'react';
import { XIcon, MapPinIcon, SearchIcon, NavigationIcon, PhoneIcon } from 'lucide-react';
interface StoreLocatorModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function StoreLocatorModal({
  isOpen,
  onClose
}: StoreLocatorModalProps) {
  const [selectedCity, setSelectedCity] = useState('all');
  const [selectedNeighborhood, setSelectedNeighborhood] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');
  const stores = [{
    id: 'HHP434',
    name: 'Al Murajihiyah',
    address: 'Riyadh, Tharwa Lane',
    availableStock: 1000,
    distance: 0.88,
    phone: '+966 50 123 4567'
  }, {
    id: 'HHP105',
    name: 'Tharwa Lane, Taiba Street',
    address: 'Riyadh, Tharwa Lane',
    availableStock: 1000,
    distance: 1.12,
    phone: '+966 50 123 4568'
  }, {
    id: 'HHP504',
    name: 'Tharwa Lane, Taiba Street',
    address: 'Riyadh, Tharwa Lane',
    availableStock: 1000,
    distance: 1.34,
    phone: '+966 50 123 4569'
  }];
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[200] overflow-y-auto animate-fadeIn" data-id="element-4426" data-mp="32rtsf27cmifh">
      <div className="fixed inset-0 bg-black/60 backdrop-blur-sm transition-opacity duration-300" onClick={onClose} data-id="element-4427" data-mp="32ph3g536b7sx" />
      <div className="flex min-h-full items-center justify-center p-4" data-id="element-4428" data-mp="3brqcsrmpgv4q">
        <div className="relative w-full max-w-3xl bg-white rounded-3xl shadow-2xl transform transition-all duration-300 scale-100 animate-slideUp z-[201]" data-id="element-4429" data-mp="3qgmf0822zdxf">
          <div className="relative bg-gradient-to-br from-[#1E2B55] via-[#2a3d6f] to-[#1E2B55] p-8 rounded-t-3xl overflow-hidden" data-id="element-4430" data-mp="3lhi6zkqw7m8o">
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full -mr-32 -mt-32" data-id="element-4431" data-mp="3uigc66d2hzsu"></div>
            <div className="absolute bottom-0 left-0 w-48 h-48 bg-white/5 rounded-full -ml-24 -mb-24" data-id="element-4432" data-mp="2539wwpnb75dx"></div>
            <div className="relative flex items-center justify-between" data-id="element-4433" data-mp="204ymodt3qsv6">
              <div data-id="element-4434" data-mp="206tabzvrcz2y">
                <h2 className="text-3xl font-bold text-white mb-2" data-id="element-4435" data-mp="41k59aky65fg">
                  Find Nearest Pharmacy
                </h2>
                <p className="text-blue-100 text-sm" data-id="element-4436" data-mp="91g8h7ltlsty">
                  Locate the closest pharmacy to you
                </p>
              </div>
              <button onClick={onClose} className="p-2.5 hover:bg-white/20 rounded-full transition-all duration-200 hover:rotate-90 group" data-id="element-4437" data-mp="e1ui2u32lau3">
                <XIcon className="w-6 h-6 text-white group-hover:scale-110 transition-transform" data-id="element-4438" data-mp="my26cilorhod" />
              </button>
            </div>
          </div>
          <div className="p-8 bg-gradient-to-b from-gray-50 to-white border-b border-gray-100" data-id="element-4439" data-mp="wppqrzjtrygc">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4440" data-mp="11pc5kdfaxmr9">
              <div className="group" data-id="element-4441" data-mp="15qnyosxdwq47">
                <label className="block text-sm font-semibold text-gray-700 mb-2.5" data-id="element-4442" data-mp="15rp7eqqxh0ir">
                  City
                </label>
                <select value={selectedCity} onChange={e => setSelectedCity(e.target.value)} className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent transition-all duration-200 hover:border-gray-300 cursor-pointer appearance-none bg-no-repeat bg-right pr-10" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236B7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\")",
                backgroundSize: '1.5rem',
                backgroundPosition: 'right 0.75rem center'
              }} data-id="element-4443" data-mp="1aq0ljdo99x6s">
                  <option value="all" data-id="element-4444" data-mp="1ifcr8h9h3h5">All Cities</option>
                  <option value="riyadh" data-id="element-4445" data-mp="3sv089kk3q7wg">Riyadh</option>
                  <option value="jeddah" data-id="element-4446" data-mp="3stgt5xa6m2w9">Jeddah</option>
                  <option value="dammam" data-id="element-4447" data-mp="3cfrcmrroj7vp">Dammam</option>
                </select>
              </div>
              <div className="group" data-id="element-4448" data-mp="3hfdpv17ico4i">
                <label className="block text-sm font-semibold text-gray-700 mb-2.5" data-id="element-4449" data-mp="3hgf1p7wclena">
                  Neighborhood
                </label>
                <select value={selectedNeighborhood} onChange={e => setSelectedNeighborhood(e.target.value)} className="w-full px-4 py-3 bg-white border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent transition-all duration-200 hover:border-gray-300 cursor-pointer appearance-none bg-no-repeat bg-right pr-10" style={{
                backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236B7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E\")",
                backgroundSize: '1.5rem',
                backgroundPosition: 'right 0.75rem center'
              }} data-id="element-4450" data-mp="38e5yl33esnjx">
                  <option value="all" data-id="element-4451" data-mp="16tcxmde5sxsi">All Neighborhoods</option>
                  <option value="tharwa" data-id="element-4452" data-mp="16uxvabvrswul">Tharwa Lane</option>
                  <option value="olaya" data-id="element-4453" data-mp="11v1ne1jycl9r">Olaya</option>
                  <option value="malaz" data-id="element-4454" data-mp="e4611jy9mi9w">Malaz</option>
                </select>
              </div>
              <div className="group" data-id="element-4455" data-mp="a2kgdcfhozp5">
                <label className="block text-sm font-semibold text-gray-700 mb-2.5" data-id="element-4456" data-mp="a3m4oiliniot">
                  Search
                </label>
                <div className="relative" data-id="element-4457" data-mp="o3n0vkqu61xy">
                  <input type="text" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search by name..." className="w-full px-4 py-3 pl-11 bg-white border-2 border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-[#1E2B55] focus:border-transparent transition-all duration-200 hover:border-gray-300" data-id="element-4458" data-mp="j2pojosic24d" />
                  <SearchIcon className="absolute left-3.5 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400 group-focus-within:text-[#1E2B55] transition-colors" data-id="element-4459" data-mp="26mjo19v4977y" />
                </div>
              </div>
            </div>
          </div>
          <div className="p-8 max-h-[500px] overflow-y-auto custom-scrollbar" data-id="element-4460" data-mp="1ivml2mlatk8u">
            <div className="flex items-center gap-2 mb-6" data-id="element-4461" data-mp="1nu7cpxmhivlo">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" data-id="element-4462" data-mp="1nuqsb7onx7wj"></div>
              <p className="text-sm font-medium text-gray-600" data-id="element-4463" data-mp="1ssim678vb43d">
                Product available in{' '}
                <span className="text-green-600 font-semibold" data-id="element-4464" data-mp="1xllhokx7gnm7">
                  {stores.length}
                </span>{' '}
                pharmacies
              </p>
            </div>
            <div className="space-y-4" data-id="element-4465" data-mp="152octznrbxnv">
              {stores.map((store, index) => <div key={store.id} className="group relative bg-white border-2 border-gray-100 rounded-2xl p-5 hover:border-[#1E2B55] hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1" style={{
              animationDelay: `${index * 100}ms`
            }} data-id="element-4466" data-mp="xkgl4tqrvjpi" data-mpi={index}>
                  <div className="absolute top-5 right-5 bg-gradient-to-r from-blue-500 to-blue-600 text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-md flex items-center gap-1.5" data-id="element-4467" data-mp="elcjw75h2u8e">
                    <NavigationIcon className="w-3 h-3" data-id="element-4468" data-mp="4vj6d0lrs51i" />
                    {store.distance} km
                  </div>
                  <div className="flex items-start gap-4 mb-4" data-id="element-4469" data-mp="3w2cgwv2gdgip">
                    <div className="flex-shrink-0 w-14 h-14 bg-gradient-to-br from-[#1E2B55] to-[#2a3d6f] rounded-2xl flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300" data-id="element-4470" data-mp="3vzzpzsepvvti">
                      <MapPinIcon className="w-7 h-7 text-white" data-id="element-4471" data-mp="1esppondy4dh5" />
                    </div>
                    <div className="flex-1 min-w-0" data-id="element-4472" data-mp="1jrj20chhxyfq">
                      <div className="flex items-center gap-2 mb-2" data-id="element-4473" data-mp="1jr0yqvwf2jyb">
                        <h3 className="font-bold text-gray-900 text-lg" data-id="element-4474" data-mp="14v1szrws4vwc">
                          {store.name}
                        </h3>
                        <span className="bg-green-100 text-green-700 text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-4475" data-mp="19rihwobszeah">
                          {store.id}
                        </span>
                      </div>
                      <p className="text-sm text-gray-600 mb-3 flex items-center gap-2" data-id="element-4476" data-mp="10urnegcwg7i0">
                        <MapPinIcon className="w-4 h-4 text-gray-400 flex-shrink-0" data-id="element-4477" data-mp="m5lq4xxmgrcr" />
                        {store.address}
                      </p>
                      <div className="flex items-center gap-6 text-sm" data-id="element-4478" data-mp="d2knj77ytidu">
                        <div className="flex items-center gap-2" data-id="element-4479" data-mp="h4ob2u7wsdfh">
                          <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-4480" data-mp="h462qz7z28r7"></div>
                          <span className="text-gray-700 font-medium" data-id="element-4481" data-mp="3umkra2xn8low">
                            Stock:{' '}
                            <span className="text-green-600 font-bold" data-id="element-4482" data-mp="3po9k5zyqgpad">
                              {store.availableStock}
                            </span>
                          </span>
                        </div>
                        <div className="flex items-center gap-2 text-gray-600" data-id="element-4483" data-mp="2k3g9cjdr3af">
                          <PhoneIcon className="w-4 h-4" data-id="element-4484" data-mp="hdontyt1iz0m" />
                          <span className="font-medium" data-id="element-4485" data-mp="cgoi5p03rya1">{store.phone}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button className="w-full bg-gradient-to-r from-[#1E2B55] to-[#2a3d6f] text-white font-semibold py-3.5 px-4 rounded-xl hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2.5 group-hover:scale-[1.02]" data-id="element-4486" data-mp="m684j4n0ya9n">
                    <MapPinIcon className="w-5 h-5" data-id="element-4487" data-mp="v87n41dotmep" />
                    <span data-id="element-4488" data-mp="1yyc8l2zox1tu">Open in Maps</span>
                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-4489" data-mp="1z05fmje7to2d">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-4490" data-mp="1l7yyov38nd1v" />
                    </svg>
                  </button>
                </div>)}
            </div>
          </div>
        </div>
      </div>
      <style data-id="element-4491" data-mp="23xnqwgfpgfdj">{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }
        .animate-slideUp {
          animation: slideUp 0.4s ease-out;
        }
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #cbd5e1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #94a3b8;
        }
      `}</style>
    </div>;
}